import { useTranslation } from 'react-i18next';
import { Row } from 'react-table';

import { Badge, BadgeVariant, Table } from '@Components';
import { CredentialSummaryItem } from '@Models';

interface CredentialSummaryListProps {
  items: CredentialSummaryItem[];
}

const STATUS_VARIANT: Record<string, BadgeVariant> = {
  Activa: 'green',
  Expirada: 'red',
  'Expira pronto': 'yellow',
  'En procesamiento': 'blue',
};

const formatDate = (value: string | null): string => (value ? new Date(value).toLocaleDateString() : '-');

const getRowClassName = (row: Row<CredentialSummaryItem>): string => (row.original.isCritical ? 'bg-error-50/40' : '');

const CredentialSummaryList = ({ items }: CredentialSummaryListProps) => {
  const { t } = useTranslation();

  const getColumns = () => [
    { Header: t('CredentialsSummary.Gln'), accessor: 'providerGln', width: 'w-[12%]' },
    { Header: t('CredentialsSummary.ProviderName'), accessor: 'providerName', width: 'w-[22%]' },
    { Header: t('CredentialsSummary.Connector'), accessor: 'connector', width: 'w-[14%]' },
    {
      Header: t('CredentialsSummary.Status'),
      accessor: 'status',
      width: 'w-[14%]',
      Cell: ({ row }: { row: Row<CredentialSummaryItem> }) => (
        <Badge variant={STATUS_VARIANT[row.original.status] ?? 'gray'} label={row.original.status} />
      ),
    },
    {
      Header: t('CredentialsSummary.DaysUntilExpiration'),
      accessor: 'daysUntilExpirationLabel',
      width: 'w-[14%]',
      Cell: ({ row }: { row: Row<CredentialSummaryItem> }) => <div>{row.original.daysUntilExpirationLabel || '-'}</div>,
    },
    {
      Header: t('CredentialsSummary.LastUpdated'),
      accessor: 'lastUpdatedAt',
      width: 'w-[12%]',
      Cell: ({ row }: { row: Row<CredentialSummaryItem> }) => <div>{formatDate(row.original.lastUpdatedAt)}</div>,
    },
    {
      Header: t('CredentialsSummary.CreatedAt'),
      accessor: 'createdAt',
      width: 'w-[12%]',
      Cell: ({ row }: { row: Row<CredentialSummaryItem> }) => <div>{formatDate(row.original.createdAt)}</div>,
    },
  ];

  return (
    <div className="flex mt-[10px]">
      <Table columns={getColumns()} data={items} pageSize={15} pagination getRowClassName={getRowClassName} />
    </div>
  );
};

export default CredentialSummaryList;
